"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backendEndpoint = void 0;
function backendEndpoint() {
    const backendEndpoint = process.env.NEXT_PUBLIC_BACKEND_ENDPOINT;
    return backendEndpoint || "https://us-east-1.webattachments.sc-prod.net";
}
exports.backendEndpoint = backendEndpoint;
//# sourceMappingURL=endpoints.js.map